module.exports = "<atn-list-box\r\n  #list\r\n  name=\"Premios\"\r\n  outputField=\"name\"\r\n  [service]=\"dataService\"\r\n></atn-list-box>\r\n\r\n<award-form\r\n  *ngIf=\"list.showForm\"\r\n  [id]=\"list.selectedItemId\"\r\n  (onSave)=\"list.hideFormAndReload()\"\r\n  (onDuplicate)=\"list.hideFormAndReload()\"\r\n  (onRemove)=\"list.hideFormAndReload()\"\r\n  (onBack)=\"list.hideForm()\"\r\n></award-form>"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/awards/award-list/award-list.component.html
// module id = ./libs/atenea-cms-brand/src/awards/award-list/award-list.component.html
// module chunks = main